import React, { useState, useEffect } from 'react'
import {
  Box, Typography, Button, Card, CardContent, Grid, CircularProgress,
  Alert, IconButton, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material'
import { Add, MoreVert, Edit, Delete, PlayArrow, Tv, Celebration } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { eventQuizAPI } from '../../services/eventQuizAPI'
import toast from 'react-hot-toast'

export default function EventQuizList() {
  const navigate = useNavigate()
  const [quizzes, setQuizzes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [anchorEl, setAnchorEl] = useState(null)
  const [selected, setSelected] = useState(null)
  const [deleteOpen, setDeleteOpen] = useState(false)

  useEffect(() => { fetchQuizzes() }, [])

  const fetchQuizzes = async () => {
    try {
      setLoading(true)
      const res = await eventQuizAPI.getAll()
      setQuizzes(res.data.quizzes || [])
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur de chargement')
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async () => {
    try {
      await eventQuizAPI.delete(selected.id)
      toast.success('Quiz supprimé')
      setDeleteOpen(false)
      fetchQuizzes()
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur')
    }
  }

  const handleStart = async (quiz) => {
    try {
      const res = await eventQuizAPI.startSession(quiz.id)
      localStorage.setItem(`event-host-${res.data.session.sessionId}`, res.data.hostSecret)
      navigate(`/event-quiz/host/${res.data.session.sessionId}`)
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur')
    }
  }

  if (loading) return <CircularProgress />

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight="bold">
            <Celebration sx={{ mr: 1, verticalAlign: 'middle' }} />
            Quiz Compétition
          </Typography>
          <Typography color="text.secondary">Organisez des compétitions de quiz en direct et en temps réel</Typography>
        </Box>
        <Button variant="contained" startIcon={<Add />} onClick={() => navigate('/event-quiz/create')}>
          Nouvelle Compétition
        </Button>
      </Box>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      {quizzes.length === 0 ? (
        <Card><CardContent sx={{ textAlign: 'center', py: 6 }}>
          <Typography color="text.secondary">Aucune compétition. Créez-en une pour commencer !</Typography>
        </CardContent></Card>
      ) : (
        <Grid container spacing={2}>
          {quizzes.map((quiz) => (
            <Grid item xs={12} sm={6} md={4} key={quiz.id}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h6" noWrap>{quiz.title}</Typography>
                    <IconButton size="small" onClick={(e) => { setAnchorEl(e.currentTarget); setSelected(quiz) }}>
                      <MoreVert />
                    </IconButton>
                  </Box>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {quiz.questionCount} questions · {quiz.status}
                  </Typography>
                  <Button fullWidth variant="contained" startIcon={<PlayArrow />} onClick={() => handleStart(quiz)}>
                    Lancer la compétition
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={() => { navigate(`/event-quiz/${selected?.id}/edit`); setAnchorEl(null) }}>
          <Edit sx={{ mr: 1 }} /> Modifier
        </MenuItem>
        <MenuItem onClick={() => { setDeleteOpen(true); setAnchorEl(null) }}>
          <Delete sx={{ mr: 1 }} /> Supprimer
        </MenuItem>
      </Menu>

      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <DialogTitle>Supprimer ce quiz ?</DialogTitle>
        <DialogContent>Cette action est irréversible.</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)}>Annuler</Button>
          <Button color="error" onClick={handleDelete}>Supprimer</Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
